import { Injectable } from '@angular/core';
import { ExcelService } from '../services/excel/excel-service';

@Injectable()
export class GlobalVariables {

  constructor(public excelService: ExcelService) { }

  private tela: string = "";
  private telaDetalhe: string = "";

  public get telaAtiva()
  {
    return this.tela;
  }

  public set telaAtiva(value: string)
  {
    this.tela = value;
  }

  public get telaDetalheAtiva()
  {
    return this.telaDetalhe;
  }

  public set telaDetalheAtiva(value:string)
  {
    this.telaDetalhe = value;
  }
  
}
